/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Icon } from '../index'

const MESSAGES = {
  chat: {
    icon: 'message-circle',
    title: 'Direkt mit Speakern chatten!',
    benefits: [
      'Fragen stellen',
      'Mit Speakern interagieren',
      'Networking betreiben',
    ],
  },
  rating: {
    icon: 'star',
    title: 'Deine Meinung zählt!',
    benefits: [
      'Sessions bewerten',
      'Feedback geben',
      'Bewertungen speichern',
    ],
  },
  appointment: {
    icon: 'calendar',
    title: 'Termin vereinbaren',
    benefits: [
      'Persönliche Gespräche',
      'Direkter Austausch',
      'Networking-Chancen',
    ],
  },
  qa: {
    icon: 'message-circle',
    title: 'Fragen stellen!',
    benefits: [
      'Fragen an Speaker stellen',
      'Antworten erhalten',
      'Mit Community diskutieren',
    ],
  },
  booking: {
    icon: 'calendar',
    title: 'Gondel-Platz buchen!',
    benefits: [
      'Umadum-Sessions buchen',
      'Experten treffen',
      'Exklusive Gespräche',
    ],
  },
  voting: {
    icon: 'thumbs-up',
    title: 'Fragen upvoten!',
    benefits: [
      'Wichtige Fragen nach oben bringen',
      'Community mitgestalten',
    ],
  },
}

export const LoginPrompt = ({ feature = 'chat', onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const msg = MESSAGES[feature] || MESSAGES.chat

  const handleRegister = () => {
    onClose?.()
    navigate('/register', { state: { from: location.pathname } })
  }

  const handleLogin = () => {
    onClose?.()
    navigate('/login', { state: { from: location.pathname } })
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0, 0, 0, 0.7)' }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div className="mb-4">
            <Icon name={msg.icon} size={48} color="#FEC626" />
          </div>
          <h2 className="text-2xl font-bold mb-4 text-gray-900">
            {msg.title}
          </h2>
          <div className="text-left mb-6">
            <p className="text-gray-600 mb-3">
              Mit einem Konto kannst du:
            </p>
            <ul className="space-y-2">
              {msg.benefits.map((benefit, i) => (
                <li key={i} className="flex items-center text-gray-700">
                  <span className="text-eggs-yellow mr-2">✓</span>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col space-y-3">
            <button
              onClick={handleRegister}
              className="w-full bg-eggs-yellow text-eggs-dark px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all min-h-[48px]"
            >
              Jetzt registrieren
            </button>
            <button
              onClick={handleLogin}
              className="w-full border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-all min-h-[48px]"
            >
              Bereits ein Konto? Anmelden
            </button>
            {onClose && (
              <button
                onClick={onClose}
                className="px-6 py-3 text-gray-600 hover:text-gray-800 min-h-[48px]"
              >
                Später
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
